var React = require('react');

function StarHalfAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M526.29,226.11l-106,103,25,145.49c3.64,20.77-13,37.4-31.66,37.4a31.75,31.75,0,0,1-14.84-3.71l-131-68.71V385.34l22.39,11.73,102.22,53.59-19.5-113.45-4.29-24.88,18.14-17.62,82.73-80.38L355.07,197.7l-25-3.64-11.26-22.63L267.75,68.14V0a31.92,31.92,0,0,1,28.81,17.81L362,150.2l146.51,21.31c26.28,3.8,36.81,36.1,17.75,54.6Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M90.48,474.5l25-145.5L9.7,226c-19-18.5-8.51-50.8,17.72-54.6l146.24-21.2L239,17.8A31.67,31.67,0,0,1,267.75,0V439.6L136.93,508.2C113.51,520.5,86,500.6,90.48,474.5Z","className":"fa-primary","key":2})]);
}

StarHalfAlt.defaultProps = {"viewBox":"0 0 536 512","className":"icon"};

module.exports = StarHalfAlt;

StarHalfAlt.default = StarHalfAlt;
